import logoSrc from '../../assets/desktop/logo.svg';

const Logo = () => {
  return <img src={logoSrc} alt='devjobs logo' />;
};

export default Logo;
